module.exports = __webpack_public_path__ + "img/adicionarempresa.ba2a7c77.png";